import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="tk-container py-20 text-center text-slate-500" data-testid="auth-loading">
        Laster …
      </div>
    );
  }
  if (!user) return <Navigate to="/logg-inn" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  // First-login forced password change — block all other routes.
  if (user.must_change_password && location.pathname !== "/bytt-passord") {
    return <Navigate to="/bytt-passord" replace />;
  }
  return children;
}
